<template>
    <div class="user-ui z-1 absolute faa-opti"
    :class="{ 'inset-0': currentPDF || currentMedia || showEditModal, 'opened': (openedElement == 'theplan') }">
        <div class="flex justify-end flex-shrink-0">
            <transition
                enter-active-class="transition-all transform duration-300 ease-out"
                leave-active-class="transition-all transform duration-300 ease-out"
                enter-class="opacity-0"
                enter-to-class="opacity-100"
                leave-class="opacity-100"
                leave-to-class="opacity-0"
                >
                <div class="flex items-center" v-if="showUI && isBlockHovered && !showUserInfo">
                    <div class="text-white bg-blue-dark rounded px-4 py-2 mr-4 ">
                        Mon profil
                    </div>
                </div>
            </transition>
            <!-- Hide/Close Profil Icon -->
            <div class="left-0 bg-white-o7 rounded-full shadow-dark cursor-pointer w-10 h-10 p-4 mr-4"
                v-if="showUI && showUserInfo"
                @click="showUserInfo = false"
            >
                <img src="@/assets/images/close-icon.svg">
            </div>

            <div 
                class="user-ui-profil bg-white rounded-l-md shadow-dark faa-fade faa-opti p-6" 
                :class="{ 'faa-fade-in': ready && show, 'shown': showUserInfo, 'cursor-pointer': !showUserInfo }"
                v-if="showUI"
                @click="(!showUserInfo ? showUserInfo = true : false)"
                @mouseover="isBlockHovered = true"
                @mouseleave="isBlockHovered = false"
            >
                <!-- Show Icon -->
                <div
                class="w-8 cursor-pointer"
                v-if="!showUserInfo">
                    <img class="m-auto" src="@/assets/images/user-icon.svg">
                </div>

                <div class="user-ui-profil-content" v-show="showUserInfo">
                    <!-- Logo & Logout -->
                    <div class="flex items-center justify-between mb-4">
                        <a target="_blank" href="https://www.foph.fr/">
                            <img class="logo" src="@/assets/images/auth-logo.svg">
                        </a>
                        <img title="Déconnexion" alt="Déconnexion" class="inline logout cursor-pointer" src="@/assets/images/logout-icon.svg" @click="logout" @load="loaded">
                    </div>

                    <!-- User name -->
                    <div 
                    v-if="userInfo"
                    title="Modifier mon profil"
                    class="flex items-center pb-1 font-main-bold text-xs capitalize cursor-pointer"
                    @click="onEditClick">
                        <span class="mr-1">{{userInfo.first_name}}</span>
                        <span>{{userInfo.name}}</span>
                        <img alt="Modifier mon profil" class="pb-1 h-5 ml-2" src="@/assets/images/edit-icon.svg">
                    </div>

                    <!-- User progress -->
                    <div>
                        <p class="text-xs text-left">Avancement des épisodes :</p>
                        <table class="relative text-xs w-full">
                            <!-- Stars -->
                            <tr class="cursor-pointer">
                                <th class="text-left flex" :class="{ 'pb-4': showDetails }">
                                    <div
                                    class="scenario-result"
                                    v-for="(result, slug) in scenarioResults"
                                    :key="slug"
                                    @click="scenarioResultClick(slug)"
                                    :title="(locationsBySlug[slug] ? locationsBySlug[slug].title : '')">
                                        <div class="scenario-result-overlay absolute text-white bg-blue-dark rounded px-4 py-2">
                                            {{(locationsBySlug[slug] ? locationsBySlug[slug].title : '') + ' (' + (Math.trunc(result.progress * 100)) + '%)'}}
                                        </div>

                                        <div
                                        class="absolute overflow-hidden"
                                        :class="{
                                            'sp-3': (result.progress > 0),
                                            'sp-5': (result.progress >= 0.3),
                                            'sp-7': (result.progress >= 0.6),
                                            'sp-f': (result.progress == 1),
                                        }">
                                            <img v-if="result.progress > 0" class="w-4 max-w-none" src="@/assets/images/star-blue-icon.svg">
                                        </div>
                                        <img class="w-4" src="@/assets/images/star-gray-icon.svg">
                                    </div>
                                </th>

                                <th class="text-center w-6" :class="{ 'pb-4': showDetails }"
                                v-show="mainLocations.length > 0"
                                @click="toggleDetails">
                                    <img
                                    class="inline w-4"
                                    src="@/assets/images/arrow-down-icon.svg"
                                    :class="{
                                        'transform rotate-180': showDetails
                                    }">
                                </th>
                            </tr>

                            <!-- Main locations details -->
                            <tbody v-show="showDetails && mainLocations.length > 0">
                                <tr class="text-left">Réussite aux quiz :</tr>
                                <tr v-for="(result, index) in mainLocations" :key="index">
                                    <td class="text-left py-2">
                                        <span class="uppercase">{{(locationsBySlug[result.slug] ? locationsBySlug[result.slug].title : '')}}</span>
                                    </td>
                                    <td class="text-right align-middle pt-1 pb-2 w-6">
                                        <img v-if="result.value > 0.75" class="inline h-5" src="@/assets/images/sun-icon.svg">
                                        <img v-else-if="result.value > 0.5" class="inline h-5" src="@/assets/images/cloudy-icon.svg">
                                        <img v-else-if="result.value > 0.25" class="inline h-5" src="@/assets/images/cloud-icon.svg">
                                        <img v-else class="inline h-5" src="@/assets/images/thunder-icon.svg">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- Media history -->
        <TheMediaHistory
        ref="themediahistory"
        @closing="closing('themediahistory')"
        @opening="opening('themediahistory')"
        @show-asset="showAsset"/>
        <ThePlan
        ref="theplan"
        @closing="closing('theplan')"
        @opening="opening('theplan')"
        v-if="showUI"/>

        <!-- PDF & Media modal -->
        <div class="user-ui-modal-container absolute inset-0 flex flex-col items-center justify-center" v-if="currentPDF || currentMedia"
        @click="currentPDF = null;currentMedia = null">
            <div
            class="absolute user-ui-modal bg-white rounded-md shadow-dark z-10 flex flex-col mb-28 mt-4"
            @click.stop>

                <!-- Modal Header -->
                <div class="user-ui-modal-header relative z-1">
                    <!-- PDF Header -->
                    <PDFViewHeader
                    v-if="currentPDF"
                    :title="currentPDF.title"
                    :pdf="currentPDF"
                    @previous="previousPDFPage()"
                    @next="nextPDFPage()"
                    @close="currentPDF = null"/>

                    <!-- Game Header -->
                    <MediaPlayerHeader
                    v-else-if="currentMedia"
                    :title="currentMedia.title"
                    :media="currentMedia"
                    :closable="true"
                    @close="currentMedia = null" />
                </div>

                <!-- Modal content -->
                <div class="user-ui-modal-content">
                    <!-- PDF -->
                    <PDFView 
                    v-if="currentPDF" 
                    :pdf="currentPDF" 
                    ref="pdf" />

                    <!-- Media node -->
                    <MediaPlayer
                    v-else-if="currentMedia"
                    :media="currentMedia"
                    ref="media"
                    @next="currentMedia = null"
                    @ended="currentMedia = null" />
                </div>
            </div>
        </div>

        <!-- User profil edit modal -->
        <TheUserEditModal v-if="showEditModal" @close="showEditModal = false" />
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'

    import TheMediaHistory from '@/components/ui/TheMediaHistory';
    import ThePlan from '@/components/ui/ThePlan'
    import TheUserEditModal from '@/components/ui/TheUserEditModal'

    import PDFViewHeader from '@/components/scenario/modal/PDFViewHeader'
    import MediaPlayerHeader from '@/components/scenario/modal/MediaPlayerHeader'

    import PDFView from '@/components/scenario/modal/PDFView'
    import MediaPlayer from '@/components/scenario/modal/MediaPlayer'

    export default {
        name: 'UserUI',
        components: {
            TheMediaHistory,
            PDFViewHeader,
            MediaPlayerHeader,
            PDFView,
            MediaPlayer,
            ThePlan,
            TheUserEditModal
        },
        data() {
            return {
                ready: false,
                show: false,
                showUserInfo: false,
                showDetails: false,
                currentPDF: null,
                currentMedia: null,
                isBlockHovered: false,
                openedElement: false,
                // Scenario result and title by unique location
                scenarioResults: {
                    expert_house: {
                        progress: 0,
                    },
                    oph_ca: {
                        progress: 0,
                    },
                    construction_site: {
                        progress: 0,
                    },
                    oph_dg: {
                        progress: 0,
                    },
                    oph_dgl: {
                        progress: 0,
                    },
                    oph_caleol: {
                        progress: 0,
                    },
                    oph_daf: {
                        progress: 0,
                    },
                    town_hall: {
                        progress: 0,
                    }
                },
                // Results by map location/building
                locationResults: [
                    {
                        value: -1,
                        slug: 'expert_house',
                        slugs: ['expert_house'],
                    }, 
                    {
                        value: -1,
                        slug: 'oph',
                        slugs: ['oph_ca', 'oph_dg', 'oph_dgl', 'oph_caleol', 'oph_daf'],
                    }, 
                    {
                        value: -1,
                        slug: 'construction_site',
                        slugs: ['construction_site'],
                    },
                    {
                        value: -1,
                        slug: 'town_hall',
                        slugs: ['town_hall'],
                    },
                ],
                showEditModal: false
            }
        },
        computed: {
            ...mapState('Auth', [ 'userInfo' ]),
            showUI() {
                return (this.$route.meta && this.$route.meta.showUI);
            },
            mainLocations() {
                return this.locationResults.filter((loc) => {
                    return (loc.value > -1)
                })
            },
            locationsBySlug() {
                if (!this.$store.state.Locations.list)
                    return {}

                return this.$store.state.Locations.list.reduce((dict, location) => {
                    dict[location.slug] = location

                    return dict
                }, {})
            },
        },
        watch: {
            showUI:{
                handler(show) {
                    setTimeout(() => {
                        this.show = show
                    }, 250)
                },
                immediate: true,
            },
            showUserInfo: {
                handler(show) {
                    if (!show) {
                        this.showDetails = false
                        this.closing('theuserinfo')
                    } else {
                        this.opening('theuserinfo')
                    }
                },
                immediate: true,
            },
            $route: {
                handler(to) {
                    // todo improve
                    // Update content when going to home page
                    if (to.name == 'Home') {
                        this.loaded()
                    }
                },
                immediate: true,
            },
        },
        methods: {
            ...mapActions('Auth', ['logout']),
            async loaded() {
                this.ready = false

                // Load locations and scenarios data todo: check concurency with other similar request
                if (this.$store.state.Locations.list.length <= 0) {
                    await this.$store.dispatch('Locations/getList')
                }
                if (this.$store.state.Scenarios.list.length <= 0) {
                    await this.$store.dispatch('Scenarios/getList') //todo: get list by locations ?
                }

                // Get scenarios completion state
                const scenarioCompletionState = await this.$store.dispatch('Logs/getByTypeSlug', {
                    type_slug: 'scenario_end',
                })
                
                const completedScenariosById = scenarioCompletionState.reduce((dict, log) => {
                    dict[log.data_key] = true

                    return dict
                }, {})

                // Get scenario progress for not completed ones
                const otherScenariosIds = this.$store.state.Scenarios.list.reduce((ids, scenario) => {
                    if (!completedScenariosById[scenario.id]) {
                        ids.push(scenario.id)
                    }

                    return ids
                }, [])

                const scenarioProgress = await this.$store.dispatch('Logs/getByKeysAndType', {
                    data_keys: otherScenariosIds,
                    type_slug: 'scenario_nodes',
                })
                
                const scenarioProgressById = scenarioProgress.reduce((dict, log) => {
                    if (!dict[log.data_key]) {
                        dict[log.data_key] = 0
                    }

                    if (log.data && log.data.progress) {
                        dict[log.data_key] = Math.max(log.data.progress, dict[log.data_key])
                    }

                    return dict
                }, {})

                let progressTotal = 0

                for (var i = 0; i < this.$store.state.Locations.list.length; i++) {
                    const location = this.$store.state.Locations.list[i]

                    if (!this.scenarioResults[location.slug])
                        continue

                    let progress = 1

                    if (location && location.scenarioLocations) {
                        for (var j = 0; j < location.scenarioLocations.length; j++) {
                            const id = location.scenarioLocations[j].scenario_id

                            if (!completedScenariosById[id]) {
                                if (scenarioProgressById[id]) {
                                    progress = scenarioProgressById[id]
                                } else {
                                    progress = 0
                                }
                                break
                            }
                        }
                    }

                    this.scenarioResults[location.slug].progress = progress
                    
                    progressTotal += progress
                }

                // Check if we need to try to send congrats email
                const progressMax = Object.keys(this.scenarioResults).length

                if (progressTotal >= progressMax) {
                    await this.$store.dispatch('Auth/sendCongratsEmailIfNeeded')
                }

                // Get details results per location
                const locationsBySlug = this.$store.state.Locations.list.reduce((dict, location) => {
                    dict[location.slug] = location

                    return dict
                }, {})

                // Create a dictionary of scenario_id => best_results_average
                const gameResults = await this.$store.dispatch('Logs/getByTypeSlug', {
                    type_slug: 'game_results',
                })

                const scenariosBestGamesResults = gameResults.reduce((dict, result) => {
                    if (result.data_key && result.data && result.data.scenario_id) {
                        const scenario_id = result.data.scenario_id
                        const game_id = result.data_key

                        // Init
                        if (!dict.bests[scenario_id]) {
                            dict.bests[scenario_id] = {}

                            dict.averages[scenario_id] = {
                                total: 0,
                                count: 0,
                            }
                        }

                        // Set/Update best results if needed
                        if (!dict.bests[scenario_id][game_id]) {
                            // Update average
                            dict.averages[scenario_id].count += 1
                            dict.averages[scenario_id].total += result.data.value

                            // Set best
                            dict.bests[scenario_id][game_id] = result.data.value
                        } else if (dict.bests[scenario_id][game_id] < result.data.value) {
                            // Update average
                            dict.averages[scenario_id].total -= dict.bests[scenario_id][game_id]
                            dict.averages[scenario_id].total += result.data.value

                            // Update best
                            dict.bests[scenario_id][game_id] = result.data.value
                        }
                    }

                    return dict
                }, {
                    bests: {},
                    averages: {},
                })

                for (var k = 0; k < this.locationResults.length; k++) {
                    if (this.locationResults[k].slugs && this.locationResults[k].slugs.length > 0) {
                        // Get the average game result for all location slug
                        const locationSlugsAverage = this.locationResults[k].slugs.reduce((result, slug) => {
                            const location = locationsBySlug[slug]
                            
                            if (location && location.scenarioLocations && location.scenarioLocations.length > 0) {

                                // Get average game results for this location scenarios
                                let locationAverage = {
                                    count: 0,
                                    total: 0,
                                }

                                for (var l = 0; l < location.scenarioLocations.length; l++) {
                                    const id = location.scenarioLocations[l].scenario_id
                                    const average = scenariosBestGamesResults.averages[id]

                                    if (average && average.count > 0) {
                                        locationAverage.count += 1
                                        locationAverage.total += (average.total / average.count)
                                    }
                                }

                                if (locationAverage.count > 0) {
                                    result.count += 1
                                    result.total += (locationAverage.total / locationAverage.count)
                                }
                            }

                            return result
                        }, {
                            total: 0,
                            count: 0,
                        })

                        // Update value if needed
                        if (locationSlugsAverage.count > 0) {
                            this.locationResults[k].value = (locationSlugsAverage.total / locationSlugsAverage.count)
                        }
                    }
                }
                
                this.ready = true
            },
            async scenarioResultClick(slug) {
                if (!this.ready)
                    return
                // todo: cehck if unlocked ???
                const location = this.$store.state.Locations.list.find((loc) => {
                    return (loc.slug == slug)
                })

                if (location && location.scenarios && location.scenarios.length > 0) {
                    // Check for introduction scenario of this locations
                    const introduction = location.scenarios.find((scenario) => {
                        return (scenario.type.slug == 'intro')
                    })

                    if (introduction && introduction.id) {
                        const logs = await this.$store.dispatch('Logs/getByKeyAndType', {
                            data_key: introduction.id,
                            type_slug: 'scenario_start',
                        })

                        if (!logs || logs.length <= 0) {
                            this.$router.push({
                                name: 'Scenario',
                                params: {
                                    id: introduction.id
                                }
                            })
                            return
                        }
                    }
                }

                // Show OPH scenario selection
                if (slug == 'oph') {
                    this.$router.push({ name: 'OPH' })
                    return
                }

                if (!location || !location.scenarios || location.scenarios.length <= 0)
                    return

                // Launch main scenario of the selected location
                const scenario = location.scenarios.find((scenario) => {
                    return (scenario.type.slug == 'scenario')
                })

                if (scenario && scenario.id) {
                    this.$router.push({
                        name: 'Scenario',
                        params: {
                            id: scenario.id
                        }
                    })
                }
            },
            toggleDetails() {
                if (this.mainLocations.length <= 0)
                    return

                this.showDetails = !this.showDetails
            },
            showAsset(asset) {
                if (asset.type.slug == 'file_pdf') {
                    this.currentPDF = asset
                } else if (asset.type.slug == 'file_video') {
                    this.currentMedia = asset
                }
            },
            opening(element) {
                if (element != 'themediahistory') {
                    this.$refs.themediahistory.close()
                }

                if (element != 'theplan') {
                    this.$refs.theplan.close()
                }

                if (element != 'theuserinfo') {
                    this.showUserInfo = false
                }

                this.openedElement = element
            },
            closing(element) {
                if (this.openedElement == element) {
                    this.openedElement = false
                }
            },
            onEditClick() {
                this.showEditModal = true
            }
        }
    }
</script>

<style lang="scss" scoped>

.user-ui {
    display: flex;
    flex-direction: column;
    @apply pl-10; // Padding to make left part of the stars overlay still visible with hidden overflow
    padding-top: 60px;
    top: 0;
    right: 0;
    overflow: hidden;

    &.opened {
        bottom: 6rem;
    }

    &-profil {
        transition: width .3s;
        width: 5rem;

        &.shown {
            width: 17rem;
            height: auto;
        }

        &-content {
            width: 14rem;
        }
    }

    .logo {
        width: 3.4rem;
    }

    /* Stars */
    tr > th:first-child > div {
        width: 1.10rem;
        margin-right: 0.25rem;
    }

    .sp-3 {
        width: 0.3rem;
    }
    
    .sp-5 {
        width: 0.5rem;
    }
    
    .sp-7 {
        width: 0.7rem;
    }

    .sp-f {
        width: auto;
    }

    .scenario-result {
        &-overlay {
            max-width: 550px;
            width: 80%;
            text-align: center;
            pointer-events: none;
            transform: translate(-50%, -102%);
            top: 0;
            opacity: 0;
            transition: opacity .5s;
        }

        &:hover {
            .scenario-result-overlay {
                opacity: 1;
            } 
        }
    }

    &-modal { // todo: improve responsive
        width: 980px;
        max-width: 90%;
        max-height: 90%;

        &.media-modal {
            width: auto;
            max-width: 70%;
        }

        &-header {
            box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);// todo
        }

        &-content {
            overflow: auto;
            height: 100%;
        }
    }
}

</style>
